import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import { migrateLegacyKeys } from "@/lib/storage-keys";

// P-23: lo script di anteprima della piattaforma di sviluppo (intercetta console e
// rete e le inoltra al frame genitore) NON deve esistere in produzione: il require
// sta dentro il ramo eliminato dalla build, quindi modulo e URL non finiscono nel bundle.
if (process.env.NODE_ENV !== "production") {
  require("@/emergentPreview").loadEmergentPreviewScriptIfInIframe();
}

// P-25: vecchie chiavi prenotami:* -> aiposto:* (solo se esistono, nessuna scrittura da anonimo).
try { migrateLegacyKeys(window.localStorage); } catch { /* storage bloccato */ }

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
